import React, { useEffect, useRef, useState } from "react";
import { Check, CheckCheck } from "lucide-react";

export const fmtTime = (iso) => new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });

export function ReadMark({ m }) {
  return m.read_at
    ? <CheckCheck size={13} className="text-red-400" data-testid={`live-read-${m.id}`} />
    : <Check size={13} className="text-zinc-500" data-testid={`live-unread-${m.id}`} />;
}

export function TypingDots({ label }) {
  return (
    <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-red-300/80" data-testid="live-typing">
      <span className="flex gap-1">
        {[0, 1, 2].map((i) => <span key={i} className="h-1.5 w-1.5 animate-bounce rounded-full bg-red-500" style={{ animationDelay: `${i * 120}ms` }} />)}
      </span>
      {label}
    </div>
  );
}

export function useAutoScroll(dep) {
  const ref = useRef(null);
  useEffect(() => { ref.current?.scrollTo({ top: ref.current.scrollHeight, behavior: "smooth" }); }, [dep]);
  return ref;
}

export function LiveComposer({ onSend, onType, placeholder, sendLabel, disabled }) {
  const [text, setText] = useState("");
  const submit = () => {
    if (!text.trim()) return;
    onSend(text);
    setText("");
    onType?.("");
  };
  return (
    <div className="flex items-end gap-2">
      <textarea data-testid="live-input" value={text} disabled={disabled} rows={2} placeholder={placeholder}
        onChange={(e) => { setText(e.target.value); onType?.(e.target.value); }}
        onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); submit(); } }}
        className="min-h-[52px] flex-1 resize-none rounded-xl border border-red-900/60 bg-black/60 px-4 py-3 text-[14px] text-zinc-100 outline-none transition-colors placeholder:text-zinc-600 focus:border-red-500/70 focus:shadow-[0_0_24px_rgba(239,68,68,0.18)]" />
      <button data-testid="live-send" onClick={submit} disabled={disabled || !text.trim()}
        className="h-[52px] rounded-xl bg-gradient-to-b from-red-500 to-red-700 px-5 text-[13px] font-bold uppercase tracking-[0.15em] text-white shadow-[0_0_24px_rgba(239,68,68,0.35)] transition-transform hover:scale-[1.03] disabled:opacity-40 disabled:hover:scale-100">
        {sendLabel}
      </button>
    </div>
  );
}
